module.exports = Promise.all([__parcel__import__("hsljJ"), __parcel__import__("aKGXg")]).then(() => parcelRequire('4MH6n'));